import { Component } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';

type InputMode = 'form' | 'json';
type PipelineStep = 'idle' | 'loading' | 'complete' | 'error';

@Component({
  selector: 'app-vendors',
  templateUrl: './vendors.component.html',
  styleUrls: ['./vendors.component.scss'],
})
export class VendorsComponent {
  /* ---------------- UI STATE ---------------- */
  inputMode: InputMode = 'form';
  pipelineStep: PipelineStep = 'idle';
  error: string | null = null;

  form: any = {
    main_service: 'Film Making',
    sub_service: 'TVC',
    skills: ['Cinematography', 'Video Editing', 'Color Grading'],
    experience_band: 'Mid to Senior (3+ yrs preferred)',
    location: 'India / Remote',
  };

  result: any = null;

  readonly API_URL =
    'https://studio-ip-887725881421.asia-south2.run.app/v1/vendors/search';

  constructor(private http: HttpClient, private snackBar: MatSnackBar) {}

  async handleRunEngine(): Promise<void> {
    this.pipelineStep = 'loading';
    this.error = null;
    this.result = null;

    try {
      const payload = this.buildPayload();

      this.result = await this.http.post(this.API_URL, payload).toPromise();

      this.pipelineStep = 'complete';
    } catch (err: any) {
      this.error =
        err?.error?.message || err?.message || 'Vendor search failed';
      this.pipelineStep = 'error';
    }
  }

  private buildPayload() {
    const vendorType = 'Agency / Studio / Experienced Freelancer';
    return {
      main_service: this.form.main_service,
      sub_service: this.form.sub_service,
      // Send both shapes so the backend can read whichever it expects.
      vendor_capability_summary: {
        vendor_type: vendorType,
        experience_band: this.form.experience_band,
        location_preference: this.form.location,
        core_skills_required: this.form.skills,
        deliverable_responsibilities: [
          'Pre-production planning',
          'On-site shooting',
          'Post-production editing',
        ],
        vendor_level_at_client_budget: 'Mid to Enterprise',
      },
      hiring_summary: {
        main_service: this.form.main_service,
        sub_service: this.form.sub_service,
        vendor_type: vendorType,
        experience_band: this.form.experience_band,
        location_preference: this.form.location,
        core_skills_required: this.form.skills,
      },
    };
  }

  onSkillsInput(event: Event): void {
    const value = (event.target as HTMLInputElement).value;

    this.form.skills = value
      .split(',')
      .map((s) => s.trim())
      .filter(Boolean);
  }

  openPortfolio(portfolioLink: string | null | undefined): void {
    if (portfolioLink && portfolioLink !== 'null') {
      window.open(portfolioLink, '_blank');
    } else {
      this.snackBar.open('No portfolio link available', 'Close', {
        duration: 2000,
      });
    }
  }
}
